var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 235",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blueprint") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-848.000000, -1740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blueprint",
    transform: "translate(879.000000, 1857.500000) rotate(90.000000) translate(-879.000000, -1857.500000) translate(761.500000, 1826.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#455059",
    x: 22,
    y: 25,
    width: 16,
    height: 37,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#455059",
    x: 83,
    y: 25,
    width: 16,
    height: 37,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#455059",
    x: 144,
    y: 25,
    width: 16,
    height: 37,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#455059",
    x: 219.5,
    y: 23.5,
    width: 9,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#455059",
    x: 193.5,
    y: 14.5,
    width: 22,
    height: 9,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,28 C196.656854,28 198,29.3431458 198,31 L198,43.999 L212,44 C213.656854,44 215,45.3431458 215,47 L215,50 C215,51.6568542 213.656854,53 212,53 L196,53 C195.829747,53 195.662806,52.9858178 195.500295,52.9585702 C195.337873,52.98576 195.170599,53 195,53 L192,53 C190.343146,53 189,51.6568542 189,50 L189,31 C189,29.3431458 190.343146,28 192,28 L195,28 Z",
    id: "Combined-Shape",
    fill: "#455059"
  }), /*#__PURE__*/React.createElement("g", {
    id: "B8",
    transform: "translate(185.000000, 35.500000) rotate(-180.000000) translate(-185.000000, -35.500000) translate(182.000000, 33.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B7",
    transform: "translate(182.000000, 43.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19611614,0.239223227 L5.19611614,0.839223227 C5.66354033,0.932708066 6,1.34312288 6,1.8198039 L6,3.1801961 C6,3.65687712 5.66354033,4.06729193 5.19611614,4.16077677 L2.19611614,4.76077677 C1.65455638,4.86908872 1.12773127,4.51787199 1.01941932,3.97631223 C1.00650469,3.91173905 1,3.84604808 1,3.7801961 L1,1.2198039 C1,0.667519153 1.44771525,0.219803903 2,0.219803903 C2.06585199,0.219803903 2.13154295,0.22630859 2.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8,
    transform: "translate(3.500000, 2.500000) scale(-1, 1) translate(-3.500000, -2.500000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 0,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B6",
    transform: "translate(198.000000, 56.500000) rotate(-90.000000) translate(-198.000000, -56.500000) translate(195.000000, 54.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19611614,0.239223227 L5.19611614,0.839223227 C5.66354033,0.932708066 6,1.34312288 6,1.8198039 L6,3.1801961 C6,3.65687712 5.66354033,4.06729193 5.19611614,4.16077677 L2.19611614,4.76077677 C1.65455638,4.86908872 1.12773127,4.51787199 1.01941932,3.97631223 C1.00650469,3.91173905 1,3.84604808 1,3.7801961 L1,1.2198039 C1,0.667519153 1.44771525,0.219803903 2,0.219803903 C2.06585199,0.219803903 2.13154295,0.22630859 2.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8,
    transform: "translate(3.500000, 2.500000) scale(-1, 1) translate(-3.500000, -2.500000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: -5.68434189e-14,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B5",
    transform: "translate(208.000000, 56.500000) rotate(-90.000000) translate(-208.000000, -56.500000) translate(205.000000, 54.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19611614,0.239223227 L5.19611614,0.839223227 C5.66354033,0.932708066 6,1.34312288 6,1.8198039 L6,3.1801961 C6,3.65687712 5.66354033,4.06729193 5.19611614,4.16077677 L2.19611614,4.76077677 C1.65455638,4.86908872 1.12773127,4.51787199 1.01941932,3.97631223 C1.00650469,3.91173905 1,3.84604808 1,3.7801961 L1,1.2198039 C1,0.667519153 1.44771525,0.219803903 2,0.219803903 C2.06585199,0.219803903 2.13154295,0.22630859 2.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8,
    transform: "translate(3.500000, 2.500000) scale(-1, 1) translate(-3.500000, -2.500000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: -5.68434189e-14,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B4",
    transform: "translate(229.000000, 37.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B3",
    transform: "translate(229.000000, 27.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B2",
    transform: "translate(209.000000, 10.500000) rotate(-90.000000) translate(-209.000000, -10.500000) translate(206.000000, 8.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "B1",
    transform: "translate(199.000000, 10.500000) rotate(-90.000000) translate(-199.000000, -10.500000) translate(196.000000, 8.000000)",
    fill: "#164DA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R3-6",
    transform: "translate(161.000000, 53.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R3-5",
    transform: "translate(161.000000, 41.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R3-4",
    transform: "translate(161.000000, 29.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R3-3",
    transform: "translate(140.000000, 31.500000) scale(-1, 1) translate(-140.000000, -31.500000) translate(137.000000, 29.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R3-2",
    transform: "translate(140.000000, 43.500000) scale(-1, 1) translate(-140.000000, -43.500000) translate(137.000000, 41.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R3-1",
    transform: "translate(140.000000, 55.500000) scale(-1, 1) translate(-140.000000, -55.500000) translate(137.000000, 53.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R2-6",
    transform: "translate(100.000000, 53.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R2-5",
    transform: "translate(100.000000, 41.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R2-4",
    transform: "translate(100.000000, 29.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R2-3",
    transform: "translate(79.000000, 31.500000) scale(-1, 1) translate(-79.000000, -31.500000) translate(76.000000, 29.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R2-2",
    transform: "translate(79.000000, 43.500000) scale(-1, 1) translate(-79.000000, -43.500000) translate(76.000000, 41.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R2-1",
    transform: "translate(79.000000, 55.500000) scale(-1, 1) translate(-79.000000, -55.500000) translate(76.000000, 53.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R1-6",
    transform: "translate(39.000000, 53.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R1-5",
    transform: "translate(39.000000, 41.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R1-4",
    transform: "translate(39.000000, 29.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R1-3",
    transform: "translate(18.000000, 31.500000) scale(-1, 1) translate(-18.000000, -31.500000) translate(15.000000, 29.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R1-2",
    transform: "translate(18.000000, 43.500000) scale(-1, 1) translate(-18.000000, -43.500000) translate(15.000000, 41.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "R1-1",
    transform: "translate(18.000000, 55.500000) scale(-1, 1) translate(-18.000000, -55.500000) translate(15.000000, 53.000000)",
    fill: "#BF002B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y9",
    transform: "translate(166.500000, 12.000000) rotate(-270.000000) translate(-166.500000, -12.000000) translate(163.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y8",
    transform: "translate(151.500000, 12.000000) rotate(-270.000000) translate(-151.500000, -12.000000) translate(148.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y7",
    transform: "translate(136.500000, 12.000000) rotate(-270.000000) translate(-136.500000, -12.000000) translate(133.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y6",
    transform: "translate(103.500000, 12.000000) rotate(-270.000000) translate(-103.500000, -12.000000) translate(100.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y5",
    transform: "translate(88.500000, 12.000000) rotate(-270.000000) translate(-88.500000, -12.000000) translate(85.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 5.7073528e-14,3.84604808 5.68434189e-14,3.7801961 L5.68434189e-14,1.2198039 C5.69978281e-14,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y4",
    transform: "translate(73.500000, 12.000000) rotate(-270.000000) translate(-73.500000, -12.000000) translate(70.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y3",
    transform: "translate(41.500000, 12.000000) rotate(-270.000000) translate(-41.500000, -12.000000) translate(38.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y2",
    transform: "translate(26.500000, 12.000000) rotate(-270.000000) translate(-26.500000, -12.000000) translate(23.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y1",
    transform: "translate(11.500000, 12.000000) rotate(-270.000000) translate(-11.500000, -12.000000) translate(8.500000, 9.500000)",
    fill: "#FEC532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19611614,0.239223227 L4.19611614,0.839223227 C4.66354033,0.932708066 5,1.34312288 5,1.8198039 L5,3.1801961 C5,3.65687712 4.66354033,4.06729193 4.19611614,4.16077677 L1.19611614,4.76077677 C0.654556382,4.86908872 0.127731275,4.51787199 0.0194193243,3.97631223 C0.00650468745,3.91173905 2.30109147e-16,3.84604808 0,3.7801961 L0,1.2198039 C1.5440923e-16,0.667519153 0.44771525,0.219803903 1,0.219803903 C1.06585199,0.219803903 1.13154295,0.22630859 1.19611614,0.239223227 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 5,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#455059",
    x: 0,
    y: 0,
    width: 181,
    height: 8,
    rx: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/blueprint.dd56d66fb95747d23fde511952e817f4.svg";
export { ForwardRef as ReactComponent };